export default __webpack_public_path__ + "static/media/006-pompom-pink.12a81b73.svg";